/**
 * Página de listagem de Configurações de Comissionamento
 *
 * @module pages/CommissionConfig
 */
import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../Tenants";
import { TypePageActions } from "../Plans";
import { AddBtn } from "@/App/CommissionConfig/Add";
import { TableData } from "@/App/CommissionConfig/Table";
import {
  getCommissionConfigData,
  searchCommissionConfigData,
} from "@/Api/commissionConfig";
import { CommissionConfigData } from "@/types/commissionConfig";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { Percent } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";

/**
 * Componente de listagem de Configurações de Comissionamento
 *
 * @returns {JSX.Element} Componente renderizado
 */
export const PageList = () => {
  const [listData, setListData] = useState(
    {} as ApiDataProps<CommissionConfigData>
  );
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();

  // Efeito para carregar dados iniciais
  useEffect(() => {
    (async () => {
      const { data } = await getCommissionConfigData();
      setListData(data?.response);
      setState("production");
    })();
  }, []);

  // Ações de paginação
  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");
        const { data } = await getCommissionConfigData(
          listData?.current_page + 1
        );
        setListData(data.response);
        setState("production");
      }
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");
        const { data } = await getCommissionConfigData(
          listData?.current_page - 1
        );
        setListData(data.response);
        setState("production");
      }
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");
        const { data } = await getCommissionConfigData(listData?.last_page);
        setListData(data?.response);
        setState("production");
      }
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-commission-ranges-list")}>
        <PageHeader
          icon={Percent}
          title="Faixas de Comissionamento"
          description="Configure as faixas de comissao"
        >
          <If condition={hasPermission("create-commission-range")}>
            <AddBtn updateFront={setListData} />
          </If>
        </PageHeader>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setListData}
            setState={setState}
            funcSearch={searchCommissionConfigData}
            placeholder="Pesquisar por nome"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={6} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
